import React from "react";
import { Container, Typography, Box, Paper, Chip } from "@mui/material";
import { School as SchoolIcon } from "@mui/icons-material";
import { TableComponent } from "../components/TableComponent";

export const ListingPage = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 2,
          }}
          className="fade-in-up"
        >
          <SchoolIcon
            sx={{ fontSize: 40, color: "primary.main", mr: 2 }}
            className="bounce-animation"
          />
          <Typography variant="h1" component="h1" className="fade-in-up">
            MPK Kurssilistaus
          </Typography>
        </Box>
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{ mb: 2 }}
          className="fade-in-up"
        >
          Tutustu saatavilla oleviin kursseihin ja ilmoittaudu mukaan
        </Typography>
        <Chip
          label="Kehitetään jatkuvasti"
          color="primary"
          variant="outlined"
          sx={{ fontSize: "0.9rem" }}
          className="fade-in-up"
        />
      </Box>

      <Paper
        elevation={2}
        sx={{
          p: 3,
          borderRadius: 2,
          backgroundColor: "background.paper",
        }}
        className="fade-in-up"
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{ mb: 3, color: "primary.main" }}
        >
          Kursseja tarjolla
        </Typography>
        <TableComponent />
      </Paper>
    </Container>
  );
};
